import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { Container, Row, Col, Card, Badge, Spinner, Button } from 'react-bootstrap';
import petrollLogo from "../assets/images/Petroll Logo small.png";

const API_URL = process.env.REACT_APP_API_URL;

const Pet = () => {
    const location = useLocation();
    const [pet, setPet] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    // Get token from query params
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");  // secure token

    useEffect(() => {
        const fetchPet = async () => {
            if (!token) {
                setNotFound(true);
                setLoading(false);
                return;
            }

            try {


                
                // Call backend endpoint using token instead of ID
                const response = await axios.get(`${API_URL}/pet/public/${token}`);

                if (!response.data) {
                    setNotFound(true);
                } else {
                    setPet(response.data);
                }
            } catch (error) {
                console.error("Error fetching pet:", error);
                setNotFound(true);
            }
            setLoading(false);
        };

        fetchPet();
    }, [token]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    return (
        <>
            {/* Logo */}
            <img
                src={petrollLogo}
                alt="Petroll Logo"
                style={{
                    position: "fixed",
                    top: "20px",
                    left: "20px",
                    width: "90px",
                    height: "auto",
                    zIndex: 9999,
                    cursor: "pointer",
                }}
            />

            {/* Not Found */}
            {notFound ? (
                <Container className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
                    <Card className="shadow-lg border-0 text-center p-4" style={{ maxWidth: "500px", borderRadius: "20px", background: "#fdfdfd" }}>
                        <img src="https://cdn-icons-png.flaticon.com/512/616/616408.png" alt="Not found" style={{ width: "120px", margin: "auto", opacity: 0.8 }} />
                        <h3 className="mt-4" style={{ fontWeight: "700", color: "#333" }}>Sorry, No Pet Found</h3>
                        <p style={{ color: "#777", fontSize: "16px" }}>We couldn't find any pet with this token. It may have been removed or never existed.</p>
                        <Button variant="primary" style={{ padding: "10px 20px", borderRadius: "8px", fontWeight: "600" }} onClick={() => window.history.back()}>
                            ← Go Back
                        </Button>
                    </Card>
                </Container>
            ) : (
                // Pet Found UI (same as before)
                <Container className="my-5">
                    <Row className="justify-content-center">
                        <Col md={10} lg={9}>
                            <Card className="shadow-lg border-0" style={{ borderRadius: "16px", overflow: "hidden", background: "#ffffff" }}>
                                <Row className="g-0">
                                    {/* LEFT — IMAGE */}
                                    <Col md={4} style={{ background: "#f7f7f7", borderRight: "1px solid #eee", display: "flex", justifyContent: "center", alignItems: "center", padding: "20px" }}>
                                        <img
                                            src={pet.base64Image ? `data:image/jpeg;base64,${pet.base64Image}` : "https://via.placeholder.com/400x300?text=No+Image"}
                                            alt={pet.petName}
                                            style={{ width: "100%", height: "auto", objectFit: "contain", borderRadius: "10px" }}
                                        />
                                    </Col>

                                    {/* RIGHT — DETAILS */}
                                    <Col md={8}>
                                        <Card.Body style={{ padding: "35px" }}>
                                            <Card.Title style={{ fontSize: "28px", fontWeight: 700, color: "#333", marginBottom: "25px" }}>
                                                {pet.petName}
                                            </Card.Title>

                                            <Card.Text style={{ fontSize: "16px", lineHeight: "1.7" }}>
                                                <strong>Owner:</strong> {pet.owner?.userName || "N/A"} <br />
                                                <strong>Breed:</strong> {pet.breed} <br />
                                                <strong>Species:</strong> {pet.species} <br />
                                                <strong>Color:</strong> {pet.color} <br />
                                                <strong>Gender:</strong> {pet.gender} <br />
                                                <strong>DOB:</strong> {pet.dob} <br />
                                                <strong>Spayed/Neutered:</strong> {pet.spayedNeutered} <br />
                                                <strong>Microchip ID:</strong> {pet.microChipId || "N/A"} <br />
                                                <strong>Emergency Contact:</strong> {pet.emergencyContact || "N/A"} <br />

                                                <div className="mt-2">
                                                    <strong>Lost Status:</strong>{" "}
                                                    {pet.lost ? (
                                                        <Badge bg="danger" style={{ fontSize: "14px" }}>Lost</Badge>
                                                    ) : (
                                                        <Badge bg="success" style={{ fontSize: "14px" }}>Safe</Badge>
                                                    )}
                                                </div>

                                                {pet.lost && pet.lostMessage && (
                                                    <p className="mt-3 p-2 rounded" style={{ background: "#fff4f4", color: "#b30000", border: "1px solid #ffdadb" }}>
                                                        <strong>Lost Message:</strong> {pet.lostMessage}
                                                    </p>
                                                )}
                                            </Card.Text>

                                            {pet.description && (
                                                <Card.Text className="mt-4" style={{ fontSize: "16px", background: "#fafafa", padding: "15px", borderRadius: "10px" }}>
                                                    <strong>Description:</strong> {pet.description}
                                                </Card.Text>
                                            )}
                                        </Card.Body>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            )}
        </>
    );
};

export default Pet;
